import Vue from "vue";
import VueCookie from "vue-cookie";
import Router from "vue-router";
import { userService } from "./services";

Vue.use(VueCookie);
Vue.use(Router);

const router = new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    linkActiveClass: "active",
    routes: [
        {
            path: "/login",
            name: "login",
            component: () => import("./pages/Login")
        },
        {
            path: "/",
            name: "themaoverzicht",
            component: () => import("./pages/ThemaOverzicht")
        },
        {
            path: "/thema/:themaid/prentenboek/:pagenr",
            name: "prentenboek",
            component: () => import("./pages/Prentenboek")
        },
        {
            path: "/thema/:themaid/praatplaat/:pagenr",
            name: "praatplaat",
            component: () => import("./pages/PraatPlaat")
        },
        {
            path: "/thema/:themaid/week/:weekid/dag/:dagid/les/:lesid/tool/:toolid",
            name: "tool",
            component: () => import("./pages/Tool")
        },
        {
            path: "*",
            component: () => import("./pages/NotFound")
        }
    ]
});
export default router

//Example source: https://jasonwatmore.com/post/2018/09/21/vuejs-basic-http-authentication-tutorial-example
// https://jasonwatmore.com/post/2018/07/06/vue-vuex-jwt-authentication-tutorial-example#auth-header-js
router.beforeEach((to, from, next) => {
    if (process.env.NODE_ENV === 'development') {
        next();
        return;
    }

    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const cookieUser = Vue.cookie.get('user');

    if (cookieUser) {

        var jsonCookieUser = JSON.parse(cookieUser);

        if (jsonCookieUser.token && jsonCookieUser.token != "") {
            localStorage.setItem('user', cookieUser);
        }
        else {
            localStorage.removeItem('user');
        }

        Vue.cookie.delete('user');
    }

    const user = localStorage.getItem('user');

    if (authRequired && user) {
        userService.authUser();
    }

    if (authRequired && !user) {
        return next({
            path: '/login',
            query: { returnUrl: to.path }
        });
    }

    next();
})
